<!--  -->
<template>
  <div class='scan-view' @click.self="stop()">
    <div id="qr-reader"></div>
    <img src="~@/assets/image/close-icon.png" @click="stop()" alt="">
  </div>
</template>

<script>

export default {
  name: 'scanView',
  components: {},
  data() {
    return {
      html5QrCode: null,
      cameraId: '',
    };
  },
  computed: {},
  watch: {},
  created() {
    
  },
  mounted() {
    
  },
  beforeDestroy () {
    this.stop()
  },
  //方法集合
  methods: {
    init (fun) {
      this.$nextTick(() => {
        if (this.$Html5Qrcode) {
          this.getCameras(fun);
        }
      })
    },
    getCameras(fun) {
      this.$Html5Qrcode.getCameras().then(devices => {
        /**
         * devices would be an array of objects of type:
         * { id: "id", label: "label" }
         */
        if (devices && devices.length) {
          if (devices.length > 1) {
            this.cameraId = devices[1].id;
          } else {
            this.cameraId = devices[0].id;
          }
          this.start(fun);
        }
      })
      .catch(err => {
        this.$emit('hide')
        this.$toast.fail('启用相机失败')
      });
    },
    start(fun) {
      this.html5QrCode = new this.$Html5Qrcode('qr-reader');
      this.html5QrCode.start(
        this.cameraId, // retreived in the previous step.
        {
          fps: 10, // sets the framerate to 10 frame per second
          qrbox: 250 // sets only 250 X 250 region of viewfinder to
          // scannable, rest shaded.
        },
        qrCodeMessage => {
          // do something when code is read. For example:
          if (qrCodeMessage) {
            fun(qrCodeMessage)
            this.stop();
          }
        },
        errorMessage => {
          // parse error, ideally ignore it. For example:
          // console.log(`QR Code no longer in front of camera.`);
        }
      )
      .catch(err => {
        // Start failed, handle it. For example,
        this.$toast.fail(`扫码失败：${err}`)
      });
    },
    stop() {
      this.$emit('hide')
      this.html5QrCode.stop().then(ignore => {
        // QR Code scanning is stopped.
        console.log('QR Code scanning stopped.');
      })
      .catch(err => {
        // Stop failed, handle it.
        console.log('Unable to stop scanning.');
      });
    },
  },
}
</script>

<style lang='less' scoped>
.scan-view {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
  background-color: #fff;
  z-index: 999999;
  > img {
    width: 80px;
    position: absolute;
    top: 20px;
    right: 20px;
    z-index: 9999999;
  }
  /deep/ #qr-reader {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    > * {
      width: 200% !important;
    }
    > div {
      width: 130% !important;
      height: 100% !important;
      position: absolute;
      left: -15% !important;
      > div:nth-child(1) {
        top: -5px !important;
        left: 0 !important;
      }
      > div:nth-child(2) {
        top: -5px !important;
        right: 0 !important;
      }
      > div:nth-child(3) {
        top: calc(100% + 0px) !important;
        left: 0 !important;
      }
      > div:nth-child(4) {
        top: calc(100% + 0px) !important;
        right: 0 !important;
      }
      > div:nth-child(5) {
        top: -5px !important;
        left: -5px !important;
      }
      > div:nth-child(6) {
        top: auto !important;
        bottom: -5px;
        left: -5px !important;
      }
      > div:nth-child(7) {
        top: -5px !important;
        right: -5px !important;
      }
      > div:nth-child(8) {
        top: auto !important;
        bottom: -5px;
        right: -5px !important;
      }
    }
  }
}
</style>